module.exports = __webpack_public_path__ + "static/media/header4.0c570588.jpg";